import { useEffect, useState } from 'react'

type UpdateSW = (reloadPage?: boolean) => Promise<void>

export function UpdateBanner() {
  const [visible,  setVisible]  = useState(false)
  const [updateSW, setUpdateSW] = useState<UpdateSW | null>(null)

  useEffect(() => {
    const handler = (e: Event) => {
      const fn = (e as CustomEvent<{ updateSW: UpdateSW }>).detail.updateSW
      setUpdateSW(() => fn)
      setVisible(true)
    }
    window.addEventListener('nudge:sw-update', handler)
    return () => window.removeEventListener('nudge:sw-update', handler)
  }, [])

  if (!visible) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999]
                 flex items-center gap-3 px-4 py-3 rounded-xl whitespace-nowrap
                 bg-indigo-950 border border-indigo-500 text-indigo-100 text-sm
                 shadow-[0_4px_24px_rgba(0,0,0,0.5)]"
    >
      <span>App updated — tap to reload</span>
      <button
        onClick={() => updateSW?.(true)}
        className="px-3 py-1 rounded-lg bg-indigo-500 text-white border-0
                   cursor-pointer font-semibold text-sm min-h-[44px]"
      >
        Reload
      </button>
      <button
        aria-label="Dismiss update banner"
        onClick={() => setVisible(false)}
        className="bg-transparent border-0 text-indigo-300 cursor-pointer
                   text-base leading-none p-1 min-h-[44px] min-w-[44px]
                   flex items-center justify-center"
      >
        ×
      </button>
    </div>
  )
}
